<template>
    <div class="lb-accordion">
        <div ref="collapsibles-group" id="accordion_new_object_group" class="pb-4 pt-1">

            <article class="message">
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_object_group-point"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'point'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="mdi mdi-32px mdi-map-marker-circle"
                                                ></i>
                                            </span>
                                            <span  class="ml-2 mt-1">
                                                {{
                                                    $t('object_group_point')
                                                }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="accordion_new_object_group-point"
                    class="message-body new-object-group is-collapsible"
                    data-parent="accordion_new_object_group"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-0 py-0">
            
                        <div ref="collapsibles-group-2" id="accordion_new_object_group-2" class="">
            
            
            
            
            
            
                            <article class="message">
                                <div class="message-header has-text-black">
                                    <a
                                        href="#accordion_new_object_group-information"
                                        data-action="collapse"
                                        style="width: 100%"
                                        :ref="'information'"
                                        class="subgroup"
                                    >
                                        <nav class="level">
                                            <div class="level-left">
                                                <div class="level-item">
                                                    <div class="level-item section-title">
                                                        <span class="icon-text">
                                                            <span class="icon is-medium">
                                                                <i
                                                                    class="mdi mdi-32px mdi-information-outline"
                                                                ></i>
                                                            </span>
                                                            <span class="ml-2 mt-1">
                                                                {{
                                                                    $t(
                                                                        'project.settings.general_information'
                                                                    )
                                                                }}</span
                                                            >
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </nav>
                                    </a>
                                </div>
                                <div
                                    id="accordion_new_object_group-information"
                                    class="message-body new-object-group is-collapsible"
                                    data-parent="accordion_new_object_group-2"
                                    data-allow-multiple="false"
                                >
                                    <div class="message-body-content px-4 py-4">
                                        <div v-if="!isMultiLang">
                                            <div class="field mb-5" v-if="model.title || content.title">
                                                <label
                                                    class="label"
                                                    >{{ $t('Object.title_label') }}</label
                                                >
                                                <div class="control">
                                                    <textarea
                                                        v-model="content.title"
                                                        class="textarea"
                                                        ref="titleObject"
                                                        :rows="titleRows"
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                class="field mb-5"
                                                v-if="model.description || content.description"
                                            >
                                                <label class="label">{{
                                                    $t('Object.description_label')
                                                }}</label>
                                                
                                                <div class="control">
                                                    <input-rich-text
                                                        class="lb-bordered"
                                                        v-if="model.description"
                                                        v-model="content.description"
                                                        :editable="true"
                                                        :placeholder="descriptionPlaceholder"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="tabs s-toggle is-fullwidth" >
                                                <ul>
                                                    <li v-for="langCode in $store.getters.project.langs" :key="langCode" :class="{'is-active':activeLanguage==langCode}">
                                                        <a @click="activeLanguage = langCode">
                                                            <span>{{ $t('LANG_'+langCode) }}</span><span class="is-required" v-if="langCode==$store.getters.project.defaultLang">*</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLanguage==langCode}">
                                                <div class="field mb-5" v-if="model.titlePerLang || content.titlePerLang">
                                                    <label
                                                        class="label"
                                                        >{{ $t('Object.title_label') }}</label
                                                    >
                                                    <div class="control">
                                                        <textarea
                                                            v-model="content.titlePerLang[langCode]"
                                                            class="textarea"
                                                            ref="titleObject"
                                                            :rows="titleRows"
                                                        />
                                                    </div>
                                                </div>
                                                <div
                                                    class="field mb-5"
                                                    v-if="model.descriptionPerLang || content.descriptionPerLang"
                                                >
                                                    <label class="label">{{
                                                        $t('Object.description_label')
                                                    }}</label>
                                                    
                                                    <div class="control">
                                                        <input-rich-text
                                                            class="lb-bordered"
                                                            v-if="model.descriptionPerLang"
                                                            v-model="content.descriptionPerLang[langCode]"
                                                            :editable="true"
                                                            :placeholder="descriptionPlaceholder"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </article>

                            <!-- positioning section -->
                            <article class="message" v-if="canHasLocation">
                                <div class="message-header has-text-black">
                                    <a
                                        href="#accordion_new_object_group-position"
                                        data-action="collapse"
                                        style="width: 100%"
                                        :ref="'position'"
                                        class="subgroup"
                                    >
                                        <nav class="level">
                                            <div class="level-left">
                                                <div class="level-item">
                                                    <div class="level-item section-title">
                                                        <span class="icon-text">
                                                            <span class="icon is-medium">
                                                                <i
                                                                    class="mdi mdi-32px mdi-map-marker-radius-outline"
                                                                ></i>
                                                            </span>
                                                            <span v-if="objectType=='clue'" class="ml-2 mt-1">
                                                                {{
                                                                    $t('Object.treasurehunt.goal')
                                                                }}</span
                                                            >
                                                            <span v-else class="ml-2 mt-1">
                                                                {{
                                                                    $t('Object.position')
                                                                }}</span
                                                            >
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </nav>
                                    </a>
                                </div>
                                <div
                                    v-if="content.location"
                                    id="accordion_new_object_group-position"
                                    class="message-body new-object-group is-collapsible"
                                    data-parent="accordion_new_object_group-2"
                                    data-allow-multiple="false"
                                >
                                    <div class="message-body-content px-4 py-4">
                                        <!-- helper section -->
                                        <div class="is-flex is-flex-direction-row-reverse">
                                            <span
                                                @click="showPositionHelp=!showPositionHelp"
                                                :data-tippy-content="
                                                    $t('Object.object_position_description')
                                                "
                                                class="icon is-small has-text-grey-light creation-helper"
                                                ><i
                                                    class="mdi mdi-24px mdi-help-circle-outline"
                                                ></i
                                            ></span>
                                        </div>
                                        <div class="notification mt-2 is-warning is-light" v-if="showPositionHelp">
                                            <div v-html="$t('Object.object_position_description')"></div>
                                        </div>

                                        <!-- address position section -->
                                        <label class="label">{{
                                            $t('Object.address_position_label')
                                        }}</label>
                                        <div class="field has-addons">
                                            <div class="control is-expanded">
                                                <input
                                                    v-model="searchText"
                                                    class="input"
                                                    type="text"
                                                    :placeholder="
                                                        $t('Object.search_address_placeholder')
                                                    "
                                                />
                                            </div>
                                            <div class="control">
                                                <a
                                                    class="button is-primary"
                                                    @click="searchAddress"
                                                >
                                                    <i class="fa fa-lg fa-caret-right" />
                                                </a>
                                            </div>
                                        </div>

                                        <!-- coordinates position section -->
                                        <label class="label">{{
                                            $t('Object.address_position_lat_lon')
                                        }}</label>
                                        <div class="columns is-mobile is-vcentered px-0">
                                            <div class="column is-5 pr-0">
                                                <div class="field has-addons">
                                                    <p class="control">
                                                        <a class="button is-static"> LAT </a>
                                                    </p>
                                                    <p class="control">
                                                        <input
                                                            class="input is-radiusless-right"
                                                            pattern="[0-9]*\.?[0-9]*"
                                                            v-model="content.location.latitude"
                                                            :placeholder="
                                                                $t(
                                                                    'Object.search_latitude_placeholder'
                                                                )
                                                            "
                                                        />
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="column is-7 pl-0">
                                                <div
                                                    class="field has-addons is-radiusless-left"
                                                >
                                                    <p class="control">
                                                        <a
                                                            class="button is-static is-borderless-left"
                                                        >
                                                            LON
                                                        </a>
                                                    </p>
                                                    <p class="control">
                                                        <input
                                                            class="input"
                                                            pattern="[0-9]*\.?[0-9]*"
                                                            type="decimal"
                                                            v-model="content.location.longitude"
                                                            :placeholder="
                                                                $t(
                                                                    'Object.search_longitude_placeholder'
                                                                )
                                                            "
                                                        />
                                                    </p>
                                                    <p class="control">
                                                        <a
                                                            class="button is-primary"
                                                            @click="goToPos"
                                                        >
                                                            <i
                                                                class="fa fa-lg fa-caret-right"
                                                            />
                                                        </a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="columns is-mobile is-vcentered px-0">
                                            <div class="column is-12 py-0 is-size-7 is-italic">
                                                <span>{{ $t('coords_system_explanation') }}</span>
                                                
                                            </div>
                                        </div>

                                        <!-- direct on map position section -->
                                        <div class="columns is-mobile is-vcentered px-0">
                                            <div class="column is-9">
                                                <label class="label">{{
                                                    $t('Object.click_position_label')
                                                }}</label>
                                            </div>

                                            <div class="column is-3 has-text-right">
                                                <label class="switch">
                                                    <input
                                                        v-model="mapPositionActive"
                                                        type="checkbox"
                                                    />
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>

                            <!-- images section -->
                            <article class="message">
                                <div class="message-header has-text-black">
                                    <a
                                        href="#accordion_new_object_group-images"
                                        data-action="collapse"
                                        style="width: 100%"
                                        :ref="'images'"
                                        class="subgroup"
                                    >
                                        <nav class="level">
                                            <div class="level-left">
                                                <div class="level-item">
                                                    <div class="level-item section-title">
                                                        <span class="icon-text">
                                                            <span class="icon is-medium">
                                                                <i
                                                                    class="mdi mdi-32px mdi-image-multiple-outline"
                                                                ></i>
                                                            </span>
                                                            <span class="ml-2 mt-1">
                                                                {{ $t('Object.images') }}</span
                                                            >
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </nav>
                                    </a>
                                </div>
                                <div
                                    id="accordion_new_object_group-images"
                                    class="message-body new-object-group is-collapsible"
                                    data-parent="accordion_new_object_group-2"
                                    data-allow-multiple="false"
                                >
                                    <div class="message-body-content px-4 py-4">
                                        <!-- helper section -->
                                        <div class="is-flex is-flex-direction-row-reverse">
                                            <span
                                                 @click="showImagesHelp=!showImagesHelp"
                                                :data-tippy-content="
                                                    $t('Object.object_images_description')
                                                "
                                                class="icon is-small has-text-grey-light creation-helper"
                                                ><i
                                                    class="mdi mdi-24px mdi-help-circle-outline"
                                                ></i
                                            ></span>
                                        </div>
                                        <div class="notification mt-2 is-warning is-light" v-if="showImagesHelp">
                                            <div v-html="$t('Object.object_images_description')"></div>
                                        </div>

                                        <!-- errors section -->
                                        <div class="mt-4">
                                            <div
                                                class="notification is-danger is-light"
                                                v-for="(error, index) in imagesErrors"
                                                :key="index"
                                            >
                                                <button
                                                    class="delete"
                                                    @click="removeMessage('images', index)"
                                                ></button>
                                                <div v-html="error" />
                                            </div>
                                        </div>

                                        <!-- content section -->
                                        <vue-dropzone
                                            ref="imagesDropzone"
                                            id="dropzone"
                                            :options="imagesDropzoneOptions"
                                            :useCustomSlot="true"
                                            class="my-4"
                                            @vdropzone-success="imageAdded"
                                            @vdropzone-error="uploadImageError"
                                            @vdropzone-removed-file="imageRemoved"
                                        >
                                            <div class="dropzone-custom-content">
                                                <h3 class="dropzone-custom-title">
                                                    {{ $t('Object.drag_and_drop_files_here') }}
                                                </h3>
                                            </div>
                                        </vue-dropzone>
                                        <draggable
                                            @end="imagesDragEndHandler"
                                            class="visualizacao sortable dropzone-previews"
                                        ></draggable>

                                        <!-- preview template -->
                                        <div
                                            class="preview"
                                            style="display: none"
                                            ref="image-preview-template"
                                            id="image-preview-template"
                                        >
                                            <li>
                                                <div>
                                                    <div class="dz-preview dz-file-preview">
                                                        <figure class="image is-1by1">
                                                            <img data-dz-thumbnail />
                                                        </figure>
                                                        <div class="dz-filename is-size-7">
                                                            <span data-dz-name=""></span>
                                                        </div>
                                                        <div class="dz-progress">
                                                            <span
                                                                class="dz-upload"
                                                                data-dz-uploadprogress
                                                            ></span>
                                                        </div>
                                                        <div class="dz-success-mark">
                                                            <!--<span>✔</span>-->
                                                            <span
                                                                class="icon is-small has-text-primary mt-1"
                                                            >
                                                                <i
                                                                    class="mdi mdi-18px mdi-check-circle-outline"
                                                                ></i>
                                                            </span>
                                                        </div>
                                                        <div class="dz-error-mark">
                                                            <span>✘</span>
                                                        </div>
                                                        <div class="dz-error-message">
                                                            <span data-dz-errormessage></span>
                                                        </div>
                                                        <a class="dz-remove" data-dz-remove="">
                                                            <span
                                                                class="icon is-small has-text-danger mt-1"
                                                            >
                                                                <i
                                                                    class="mdi mdi-18px mdi-trash-can"
                                                                ></i> </span
                                                        ></a>
                                                    </div>
                                                </div>
                                            </li>
                                        </div>
                                    </div>
                                </div>
                            </article>

                            <!-- audio section -->
                            <article class="message">
                                <div class="message-header has-text-black">
                                    <a
                                        href="#accordion_new_object_group-audio"
                                        data-action="collapse"
                                        style="width: 100%"
                                        :ref="'audio'"
                                        class="subgroup"
                                    >
                                        <nav class="level">
                                            <div class="level-left">
                                                <div class="level-item">
                                                    <div class="level-item section-title">
                                                        <span class="icon-text">
                                                            <span class="icon is-medium">
                                                                <i
                                                                    class="mdi mdi-32px mdi-waveform"
                                                                ></i>
                                                            </span>
                                                            <span class="ml-2 mt-1">
                                                                {{ $t('Object.audio') }}</span
                                                            >
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </nav>
                                    </a>
                                </div>
                                <div
                                    id="accordion_new_object_group-audio"
                                    class="message-body new-object-group is-collapsible"
                                    data-parent="accordion_new_object_group-2"
                                    data-allow-multiple="false"
                                >
                                    <div class="message-body-content px-4 py-4">
                                        <!-- helper section -->
                                        <div class="is-flex is-flex-direction-row-reverse">
                                            <span
                                                @click="showAudiosHelp=!showAudiosHelp"
                                                :data-tippy-content="
                                                    $t('Object.object_audio_description')
                                                "
                                                class="icon is-small has-text-grey-light creation-helper"
                                                ><i
                                                    class="mdi mdi-24px mdi-help-circle-outline"
                                                ></i
                                            ></span>
                                        </div>
                                        <div class="notification mt-2 is-warning is-light" v-if="showAudiosHelp">
                                            <div v-html="$t('Object.object_audio_description')"></div>
                                        </div>
                                        <!-- errors section -->
                                        <div class="mt-4">
                                            <div
                                                class="notification is-danger is-light"
                                                v-for="(error, index) in audioErrors"
                                                :key="index"
                                            >
                                                <button
                                                    class="delete"
                                                    @click="removeMessage('audio', index)"
                                                ></button>
                                                <div v-html="error" />
                                            </div>
                                        </div>

                                        <!-- content section -->

                                        <div v-if="!isMultiLang">
                                            <vue-dropzone
                                                ref="audioDropzone"
                                                id="audio-dropzone"
                                                :options="audioDropzoneOptions"
                                                :useCustomSlot="true"
                                                class="my-4"
                                                @vdropzone-error="uploadAudioError"
                                                @vdropzone-success="audioFileAdded"
                                                @vdropzone-removed-file="audioRemoved"
                                            >
                                                <div class="dropzone-custom-content">
                                                    <h3 class="dropzone-custom-title">
                                                        {{
                                                            $t(
                                                                'Object.drag_and_drop_audio_file_here'
                                                            )
                                                        }}
                                                    </h3>
                                                    <p class="subtitle is-size-7 has-text-grey">
                                                        {{ $t('Object.upload_audio_desc') }}
                                                    </p>
                                                </div>
                                            </vue-dropzone>

                                            <ul class="audio-preview-file dropzone-previews"></ul>

                                            <!-- preview template -->
                                            <div
                                                class="preview"
                                                style="display: none"
                                                ref="audio-preview-template"
                                                id="audio-preview-template"
                                            >
                                                <li>
                                                    <div>
                                                        <div class="dz-preview dz-file-preview">
                                                            <div class="dz-progress">
                                                                <span
                                                                    class="dz-upload"
                                                                    data-dz-uploadprogress
                                                                ></span>
                                                            </div>
                                                            <div
                                                                class="columns is-mobile is-vcentered"
                                                            >
                                                                <div class="column is-10 px-5 py-5">
                                                                    <div
                                                                        class="dz-filename is-size-6"
                                                                    >
                                                                        <span
                                                                            data-dz-name=""
                                                                        ></span>
                                                                    </div>
                                                                    <div class="dz-size is-size-7">
                                                                        <span
                                                                            data-dz-size=""
                                                                        ></span>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="column is-2 has-text-right pr-5"
                                                                >
                                                                    <a
                                                                        class="dz-remove"
                                                                        data-dz-remove=""
                                                                    >
                                                                        <span
                                                                            class="icon has-text-danger mt-1"
                                                                        >
                                                                            <i
                                                                                class="mdi mdi-24px mdi-trash-can"
                                                                            ></i> </span
                                                                    ></a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="tabs s-toggle is-fullwidth" >
                                                <ul>
                                                    <li v-for="langCode in $store.getters.project.langs" :key="langCode" :class="{'is-active':activeLanguage==langCode}">
                                                        <a @click="activeLanguage = langCode">
                                                            <span>{{ $t('LANG_'+langCode) }}</span><span class="is-required" v-if="langCode==$store.getters.project.defaultLang">*</span>
                                                        </a>
                                                    </li>
                        
                                                </ul>
                                            </div>
                                            <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLanguage==langCode}">
                                                <App-upload-file
                                                    :boxText="'Object.drag_and_drop_audio_file_here'"
                                                    :boxTextDesc="'Object.upload_audio_desc'"
                                                    :content="getAudioForLang(langCode)"
                                                    :type="'audio'"
                                                    :lang="langCode"
                                                    :isActive="true"
                                                    @addError="uploadError"
                                                    @fileAdded="fileAddedPerLang"
                                                    @fileRemoved="fileRemovedPerLang"
                                                ></App-upload-file>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>

                            <!-- files section -->
                            <article class="message">
                                <div class="message-header has-text-black">
                                    <a
                                        href="#accordion_new_object_group-files"
                                        data-action="collapse"
                                        style="width: 100%"
                                        :ref="'files'"
                                        class="subgroup"
                                    >
                                        <nav class="level">
                                            <div class="level-left">
                                                <div class="level-item">
                                                    <div class="level-item section-title">
                                                        <span class="icon-text">
                                                            <span class="icon is-medium">
                                                                <i
                                                                    class="mdi mdi-32px mdi-file-document-outline"
                                                                ></i>
                                                            </span>
                                                            <span class="ml-2 mt-1">
                                                                {{ $t('Object.files') }}</span
                                                            >
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </nav>
                                    </a>
                                </div>
                                <div
                                    id="accordion_new_object_group-files"
                                    class="message-body new-object-group is-collapsible"
                                    data-parent="accordion_new_object_group-2"
                                    data-allow-multiple="false"
                                >
                                    <div class="message-body-content px-4 py-4">
                                        <!-- helper section -->
                                        <div class="is-flex is-flex-direction-row-reverse">
                                            <span
                                                @click="showFilesHelp=!showFilesHelp"
                                                :data-tippy-content="
                                                    $t('Object.object_files_description')
                                                "
                                                class="icon is-small has-text-grey-light creation-helper"
                                                ><i
                                                    class="mdi mdi-24px mdi-help-circle-outline"
                                                ></i
                                            ></span>
                                        </div>
                                        <div class="notification mt-2 is-warning is-light" v-if="showFilesHelp">
                                            <div v-html="$t('Object.object_files_description')"></div>
                                        </div>

                                        <!-- errors section -->
                                        <div class="mt-4">
                                            <div
                                                class="notification is-danger is-light"
                                                v-for="(error, index) in filesErrors"
                                                :key="index"
                                            >
                                                <button
                                                    class="delete"
                                                    @click="removeMessage('files', index)"
                                                ></button>
                                                <div v-html="error" />
                                            </div>
                                        </div>

                                        <!-- content section -->
                                         <div v-if="!isMultiLang">
                                            <vue-dropzone
                                                ref="filesDropzone"
                                                id="files-dropzone"
                                                :options="filesDropzoneOptions"
                                                :useCustomSlot="true"
                                                class="my-4"
                                                @vdropzone-error="uploadFilesError"
                                                @vdropzone-success="filesAdded"
                                                @vdropzone-removed-file="fileRemoved"
                                            >
                                                <div class="dropzone-custom-content">
                                                    <h3 class="dropzone-custom-title">
                                                        {{ $t('Object.drag_and_drop_files_here') }}
                                                    </h3>
                                                    <p class="subtitle is-size-7 has-text-grey">
                                                        {{ $t('Object.upload_files_desc') }}
                                                    </p>
                                                </div>
                                            </vue-dropzone>

                                            <draggable
                                                @end="filesDragEndHandler"
                                                class="files-preview-file dropzone-previews"
                                            ></draggable>

                                            <!-- preview template -->
                                            <div
                                                class="preview"
                                                style="display: none"
                                                ref="files-preview-template"
                                                id="files-preview-template"
                                            >
                                                <li>
                                                    <div>
                                                        <div class="dz-preview dz-file-preview">
                                                            <div class="dz-progress">
                                                                <span
                                                                    class="dz-upload"
                                                                    data-dz-uploadprogress
                                                                ></span>
                                                            </div>
                                                            <div
                                                                class="columns is-mobile is-vcentered"
                                                            >
                                                                <div class="column is-10 px-5 py-5">
                                                                    <div
                                                                        class="dz-filename is-size-6"
                                                                    >
                                                                        <span
                                                                            data-dz-name=""
                                                                        ></span>
                                                                    </div>
                                                                    <div class="dz-size is-size-7">
                                                                        <span
                                                                            data-dz-size=""
                                                                        ></span>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="column is-2 has-text-right pr-5"
                                                                >
                                                                    <a
                                                                        class="dz-remove"
                                                                        data-dz-remove=""
                                                                    >
                                                                        <span
                                                                            class="icon has-text-danger mt-1"
                                                                        >
                                                                            <i
                                                                                class="mdi mdi-24px mdi-trash-can"
                                                                            ></i> </span
                                                                    ></a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="tabs s-toggle is-fullwidth" >
                                                <ul>
                                                    <li v-for="langCode in $store.getters.project.langs" :key="langCode" :class="{'is-active':activeLanguage==langCode}">
                                                        <a @click="activeLanguage = langCode">
                                                            <span>{{ $t('LANG_'+langCode) }}</span><span class="is-required" v-if="langCode==$store.getters.project.defaultLang">*</span>
                                                        </a>
                                                    </li>
                        
                                                </ul>
                                            </div>
                                            <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLanguage==langCode}">
                                                <App-upload-file
                                                    :boxText="'Object.drag_and_drop_files_here'"
                                                    :boxTextDesc="'Object.upload_files_desc'"
                                                    :content="getFilesForLang(langCode)"
                                                    :type="'files'"
                                                    :lang="langCode"
                                                    :isActive="true"
                                                    @addError="uploadError"
                                                    @fileAdded="fileAddedPerLang"
                                                    @fileRemoved="fileRemovedPerLang"
                                                ></App-upload-file>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>

                            <!-- video section -->
                            <article class="message">
                                <div class="message-header has-text-black">
                                    <a
                                        href="#accordion_new_object_group-video"
                                        data-action="collapse"
                                        style="width: 100%"
                                        :ref="'video'"
                                        class="subgroup"
                                    >
                                        <nav class="level">
                                            <div class="level-left">
                                                <div class="level-item">
                                                    <div class="level-item section-title">
                                                        <span class="icon-text">
                                                            <span class="icon is-medium">
                                                                <i
                                                                    class="mdi mdi-32px mdi-play-circle"
                                                                ></i>
                                                            </span>
                                                            <span class="ml-2 mt-1">
                                                                {{ $t('Object.video') }}</span
                                                            >
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </nav>
                                    </a>
                                </div>
                                <div
                                    id="accordion_new_object_group-video"
                                    class="message-body new-object-group is-collapsible"
                                    data-parent="accordion_new_object_group-2"
                                    data-allow-multiple="false"
                                >
                                    <div class="message-body-content px-4 py-4">
                                        <!-- helper section -->
                                        <div class="is-flex is-flex-direction-row-reverse">
                                            <span
                                                @click="showVideoHelp=!showVideoHelp"
                                                :data-tippy-content="
                                                    $t('Object.object_video_description')
                                                "
                                                class="icon is-small has-text-grey-light creation-helper"
                                                ><i
                                                    class="mdi mdi-24px mdi-help-circle-outline"
                                                ></i
                                            ></span>
                                        </div>
                                        <div class="notification mt-2 is-warning is-light" v-if="showVideoHelp">
                                            <div v-html="$t('Object.object_video_description')"></div>
                                        </div>

                                        <!-- content section -->
                                         <div v-if="!isMultiLang">
                                            <label class="label">{{
                                                $t('Object.video_label')
                                            }}</label>
                                            <div class="field">
                                                <div class="control is-expanded">
                                                    <input
                                                        v-model="content.video"
                                                        class="input"
                                                        type="text"
                                                        @input="validateVideoURL"
                                                    />
                                                </div>
                                            </div>
                                            <p v-if="objectErrors.video" class="help is-danger">
                                                {{ objectErrors.video }}
                                            </p>
                                         </div>
                                         <div v-else>
                                            <div class="tabs s-toggle is-fullwidth" >
                                                <ul>
                                                    <li v-for="langCode in $store.getters.project.langs" :key="langCode" :class="{'is-active':activeLanguage==langCode}">
                                                        <a @click="activeLanguage = langCode">
                                                            <span>{{ $t('LANG_'+langCode) }}</span><span class="is-required" v-if="langCode==$store.getters.project.defaultLang">*</span>
                                                        </a>
                                                    </li>
                        
                                                </ul>
                                            </div>
                                            <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLanguage==langCode}">
                                                <label class="label">{{
                                                    $t('Object.video_label')
                                                }}</label>
                                                <div class="field">
                                                    <div class="control is-expanded">
                                                        <input
                                                            v-model="content.videoPerLang[langCode]"
                                                            class="input"
                                                            type="text"
                                                            @input="validateVideoURLPerLang"
                                                        />
                                                    </div>
                                                </div>
                                                <p v-if="objectErrors.videoPerLang && objectErrors.videoPerLang[langCode]" class="help is-danger">
                                                    {{ objectErrors.videoPerLang[langCode] }}
                                                </p>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </article>

                            <!-- embed section -->
                            <article class="message">
                                <div class="message-header has-text-black">
                                    <a
                                        href="#accordion_new_object_group-embed"
                                        data-action="collapse"
                                        style="width: 100%"
                                        :ref="'embed'"
                                        class="subgroup"
                                    >
                                        <nav class="level">
                                            <div class="level-left">
                                                <div class="level-item">
                                                    <div class="level-item section-title">
                                                        <span class="icon-text">
                                                            <span class="icon is-medium">
                                                                <i
                                                                    class="mdi mdi-32px mdi-xml"
                                                                ></i>
                                                            </span>
                                                            <span class="ml-2 mt-1">
                                                                {{ $t('Object.embed') }}</span
                                                            >
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </nav>
                                    </a>
                                </div>
                                <div
                                    id="accordion_new_object_group-embed"
                                    class="message-body new-object-group is-collapsible"
                                    data-parent="accordion_new_object_group-2"
                                    data-allow-multiple="false"
                                >
                                    <div class="message-body-content px-4 py-4">
                                        <!-- helper section -->
                                        <div class="is-flex is-flex-direction-row-reverse">
                                            <span
                                                @click="showEmbedHelp=!showEmbedHelp"
                                                :data-tippy-content="
                                                    $t('Object.object_embed_description')
                                                "
                                                class="icon is-small has-text-grey-light creation-helper"
                                                ><i
                                                    class="mdi mdi-24px mdi-help-circle-outline"
                                                ></i
                                            ></span>
                                        </div>
                                        <div class="notification mt-2 is-warning is-light" v-if="showEmbedHelp">
                                            <div v-html="$t('Object.object_embed_description')"></div>
                                        </div>

                                        <!-- content section -->
                                        <label class="label">{{
                                            $t('Object.embed_label')
                                        }}</label>
                                        <div class="field">
                                            <div class="control is-expanded">
                                                <textarea
                                                    v-model="content.embed"
                                                    class="textarea"
                                                    rows="4"
                                                    @input="validateEmbedCode"
                                                />
                                            </div>
                                        </div>
                                        <p v-if="objectErrors.embed" class="help is-danger">
                                            {{ objectErrors.embed }}
                                        </p>
                                    </div>
                                </div>
                            </article>

                            <!-- url section -->
                            <article class="message">
                                <div class="message-header has-text-black">
                                    <a
                                        href="#accordion_new_object_group-url"
                                        data-action="collapse"
                                        style="width: 100%"
                                        :ref="'url'"
                                        class="subgroup"
                                    >
                                        <nav class="level">
                                            <div class="level-left">
                                                <div class="level-item">
                                                    <div class="level-item section-title">
                                                        <span class="icon-text">
                                                            <span class="icon is-medium">
                                                                <i
                                                                    class="mdi mdi-32px mdi-link-variant"
                                                                ></i>
                                                            </span>
                                                            <span class="ml-2 mt-1">
                                                                {{ $t('Object.url') }}</span
                                                            >
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </nav>
                                    </a>
                                </div>

                                <div
                                    id="accordion_new_object_group-url"
                                    class="message-body new-object-group is-collapsible"
                                    data-parent="accordion_new_object_group-2"
                                    data-allow-multiple="false"
                                >
                                    <div class="message-body-content px-4 py-4">
                                        <!-- helper section -->
                                        <div class="is-flex is-flex-direction-row-reverse">
                                            <span
                                                 @click="showUrlHelp=!showUrlHelp"
                                                :data-tippy-content="
                                                    $t('Object.object_url_description')
                                                "
                                                class="icon is-small has-text-grey-light creation-helper"
                                                ><i
                                                    class="mdi mdi-24px mdi-help-circle-outline"
                                                ></i
                                            ></span>
                                        </div>

                                        <div class="notification mt-2 is-warning is-light" v-if="showUrlHelp">
                                            <div v-html="$t('Object.object_url_description')"></div>
                                        </div>
                                        <!-- content section -->
                                        <div v-if="!isMultiLang">
                                            <div class="field">
                                                <label class="label">{{
                                                    $t('Object.url_label')
                                                }}</label>
                                                <div class="control">
                                                    <input
                                                        class="input"
                                                        type="text"
                                                        v-model="content.url"
                                                        @input="validateURL"
                                                    />
                                                </div>
                                            </div>
                                            <p v-if="objectErrors.url" class="help is-danger">
                                                {{ objectErrors.url }}
                                            </p>
                                        </div>
                                        <div v-else>
                                            <div class="tabs s-toggle is-fullwidth" >
                                                <ul>
                                                    <li v-for="langCode in $store.getters.project.langs" :key="langCode" :class="{'is-active':activeLanguage==langCode}">
                                                        <a @click="activeLanguage = langCode">
                                                            <span>{{ $t('LANG_'+langCode) }}</span><span class="is-required" v-if="langCode==$store.getters.project.defaultLang">*</span>
                                                        </a>
                                                    </li>
                        
                                                </ul>
                                            </div>
                                            <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLanguage==langCode}">
                                                
                                                <div class="field">
                                                    <label class="label">{{$t('Object.url_label')}}</label>
                                                    <div class="control">
                                                        <input
                                                            class="input"
                                                            type="text"
                                                            v-model="content.urlPerLang[langCode]"
                                                            @input="validateURLPerLang"
                                                        />
                                                    </div>
                                                </div>
                                                <p v-if="objectErrors.urlPerLang && objectErrors.urlPerLang[langCode]" class="help is-danger">
                                                    {{ objectErrors.urlPerLang[langCode] }}
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>

                        </div>


                        
                    </div>
                </div>
            </article>

            



            <!-- questions section -->
            <article class="message">
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_object_group-questions"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'questions'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="mdi mdi-32px mdi-help-rhombus-outline"
                                                ></i>
                                            </span>
                                            <span  class="ml-2 mt-1">
                                                {{
                                                    $t('object_group_questions')
                                                }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="accordion_new_object_group-questions"
                    class="message-body new-object-group is-collapsible"
                    data-parent="accordion_new_object_group"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-0 py-0">

                        <l-project-object-questions
                            :content="content.questions"
                            :canDelete="canDelete"
                            @cancel="$emit('cancel')"
                            @showPreview="showPreview"
                            @save="validateAndSave"
        
                        />
                        
                    </div>
                </div>
            </article>
            
        </div>

        <div v-if="errorsOnSave" class="validationErrors px-5">
            <div class="notification is-danger is-light">
                <button class="delete" @click="errorsOnSave = false"></button>
                <p class="has-text-weight-bold is-size-6 pb-2">
                    {{ $t('Object.errors_on_save') }}
                </p>
                <p class="is-size-6">
                    {{ $t('Object.errors_on_save_desc') }}
                </p>
                <br />
                <p
                    class="is-size-6 has-text-italic"
                    v-for="(error, index) in objectErrors"
                    :key="index"
                >
                    - {{ error }}
                </p>
            </div>
        </div>

        <div
            v-if="canDelete"
            class="delete-button is-pulled-right px-2 pb-2 mr-2"
        >
            <a @click="deleteObject" class="primary-font button is-primary is-inverted">
                <span class="pr-4 is-size-6">{{ deleteText }}</span>
                <span class="icon"
                    ><i
                        class="mdi mdi-32px mdi-close-circle"
                        aria-hidden="true"
                    ></i
                ></span>
            </a>
        </div>

        
        <l-projectObject-modal-preview
            v-if="showModalPreview"
            :type="previewType"
            :content="previewData"
            :active.sync="showModalPreview"
            @close="showModalPreview = false"
        />

        <l-project-object-preview
            :object="content"
            v-if="showPreviewModal"
            @close="showPreviewModal = false"
        />
    </div>
</template>

<script>
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import InputRichText from '@/components/InputRichText';
import _ from 'underscore';
import GeoCodingOSM from 'geocoding-osm';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import LProjectObjectModalPreview from '@/components/LProjectObjectModalPreview';
import LProjectObjectInputTags from '@/components/LProjectObjectInputTags';
import LProjectObjectPreview from '@/components/LProjectObjectPreview';
import InputURL from '@/components/InputURL';
import LObjectCardRelated from '@/components/LObjectCardRelated';
import LProjectObjectQuestions from '@/components/LProjectObjectQuestions';
import Swal from 'sweetalert2';
import AppUploadFile from '@/components/AppUploadFile';

export default {
    name: 'LProjectObjectGroup',
    components: {
        InputRichText,
        vueDropzone: vue2Dropzone,
        draggable,
        LProjectObjectInputTags,
        LProjectObjectModalPreview,
        LProjectObjectPreview,
        InputURL,
        LObjectCardRelated,
        LProjectObjectQuestions,
        AppUploadFile
    },
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
        model: {
            type: Object,
            default() {
                return {};
            },
        },
        hasLocation: {
            type: Boolean,
            default: false,
        },
        mapPositionActivation: {
            type: Boolean,
            default: false,
        },
        canHasLocation: {
            type: Boolean,
            default: true,
        },
        objectType: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            searchText: '',
            activePoint: undefined,
            lat: '',
            lon: '',
            mapPositionActive: false,
            imagesDropzoneOptions: {
                url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                thumbnailWidth: 150,
                maxFilesize: 4,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                previewsContainer: '.visualizacao',
                parallelUploads: 1,
                //disablePreviews: true,
                acceptedFiles: 'image/gif,image/jpeg,image/png',
                dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                dictResponseError: this.$t('dropzone.dict_response_error'),
                dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                dictCancelUploadConfirmation: this.$t(
                    'dropzone.dict_cancel_upload_confirmation'
                ),
                dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                dictMaxFilesExceeded: this.$t(
                    'dropzone.dict_max_files_exceeded'
                ),
            },
            audioDropzoneOptions: {
                url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                thumbnailWidth: 150,
                maxFilesize: 4,
                maxFiles: 1,
                //headers: { 'My-Awesome-Header': 'header value' },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                previewsContainer: '.audio-preview-file',
                acceptedFiles: 'audio/mpeg',

                dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                dictResponseError: this.$t('dropzone.dict_response_error'),
                dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                dictCancelUploadConfirmation: this.$t(
                    'dropzone.dict_cancel_upload_confirmation'
                ),
                dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                dictMaxFilesExceeded: this.$t(
                    'dropzone.dict_max_files_exceeded'
                ),
            },
            showAudioPlayer: false,
            audioFile: '',

            filesDropzoneOptions: {
                url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                thumbnailWidth: 150,
                maxFilesize: 4,
                //headers: { 'My-Awesome-Header': 'header value' },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                previewsContainer: '.files-preview-file',
                acceptedFiles:
                    'application/pdf,application/vnd.ms-powerpoint,application/zip,application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.spreadsheet,application/vnd.oasis.opendocument.presentation,application/epub+zip,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

                dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                dictResponseError: this.$t('dropzone.dict_response_error'),
                dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                dictCancelUploadConfirmation: this.$t(
                    'dropzone.dict_cancel_upload_confirmation'
                ),
                dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                dictMaxFilesExceeded: this.$t(
                    'dropzone.dict_max_files_exceeded'
                ),
            },
            videoId: undefined,
            embedCode: undefined,
            showEmbedPreview: false,

            showModalPreview: false,
            previewType: undefined,
            previewData: undefined,

            showPreviewModal: false,

            saving: false,
            originalContent: {},

            objectErrors: {},
            filesErrors: [],
            audioErrors: [],
            imagesErrors: [],
            errorsOnSave: false,
            collapsiblesGroup: undefined,
            activeLanguage: this.$store.getters.project.langs && this.$store.getters.project.defaultLang ? this.$store.getters.project.defaultLang : this.$store.getters.project.langs && !this.$store.getters.project.defaultLang ? this.$store.getters.project.langs[0] : '',
            defaultLang: this.$store.getters.project.defaultLang ? this.$store.getters.project.defaultLang : '',

            showUrlHelp: false,
            showEmbedHelp: false, 
            showVideoHelp: false,
            showFilesHelp: false,
            showAudiosHelp: false,
            showImagesHelp: false,
            showPositionHelp: false,
        };
    },
    computed: {
        titleRows(){
            return 1;
        },
        hasAccess() {
            if (this.isCreation) {
                return true;
            }
            return this.content.accessLevel == 'administrator';
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        titlePlaceholder() {
            if (
                this.$store.getters.project.type == 'treasurehunt' &&
                this.$store.getters.projectContent.length == 1
            ) {
                return 'creation.treasurehunt_title_hint';
            }
            return 'creation.title_hint';
        },
        descriptionPlaceholder() {
            if (
                this.$store.getters.project.type == 'treasurehunt' &&
                this.$store.getters.projectContent.length == 1
            ) {
                return this.$t('creation.treasurehunt_description_hint');
            }
            return '';
        },
        hasChanges() {
            return this.content !== this.originalContent;
        },
        correctAnswers() {
            // console.log('object', this.content);
            // console.log('answers', this.content.answers);
            // console.log('answerType', this.content.answerType);
            return _.filter(this.content.answers, (answer) => {
                if (answer.correct) {
                    return answer && answer.value;
                }
            });
        },
        cleanedAnswers() {
            return _.filter(this.content.answers, (answer) => {
                if (answer.value) {
                    return answer;
                }
            });
        },
        canDelete() {
            return this.content._id != 'draft' && this.hasAccess;
        },
        deleteText(){
            if(this.objectType){
                switch (this.objectType) {
                    case 'object':
                        return this.$t('remove_card');
                    case 'clue':
                        return this.$t('remove_clue');
                    case 'question':
                        if(this.$store.getters.project.format == 'PROJECT_TYPE_GEOQUIZ'){
                            return this.$t('remove_question_group');
                        }else{
                            return this.$t('remove_question');
                        }
                        
                    default:
                        return this.$t('remove_object');
                }
            } else {
                switch (this.$store.getters.project.format){
                    case 'PROJECT_TYPE_WALL':
                        return this.$t('remove_card');
                    case 'PROJECT_TYPE_QUIZ':
                        return this.$t('remove_question');
                    case 'PROJECT_TYPE_QUIZHUNT':
                        return this.$t('remove_question');
                    case 'PROJECT_TYPE_GEOQUIZ':
                        return this.$t('remove_question_group');
                    case 'PROJECT_TYPE_MAP':
                        return this.$t('remove_point');
                    default:
                        return this.$t('remove_object');
                }
            }
            
        },
        isMultiLang() {
            return this.$store.getters.project.langs && this.$store.getters.project.langs.length > 0;  
        },
    },
    watch: {
        mapPositionActivation: {
            handler: function () {
                if (!this.mapPositionActivation) {
                    this.mapPositionActive = false;
                }
            },
            immediate: true,
        },
        mapPositionActive: {
            handler: function () {
                if (this.mapPositionActive) {
                    this.$emit('activateMapPosition', this.mapPositionActive);
                }
            },
            immediate: true,
        },
    },
    beforeMount() {
        if (this.isMultiLang) { 
            // console.log('lprojectgroupobject')
            if (this.content.title) {
                if (!this.content.titlePerLang) {
                    this.content.titlePerLang = {};
                    // console.log("cal crear i assignar el títol per l'idioma per defecte")
                    this.content.titlePerLang[this.defaultLang] = this.content.title;
                } else if (!this.content.titlePerLang[this.defaultLang]) {
                    // console.log("cal assignar el títol per l'idioma per defecte",this.content.title)
                    this.content.titlePerLang[this.defaultLang] = this.content.title;
                }
            }

            if (this.content.description) {
                if (!this.content.descriptionPerLang) {
                    this.content.descriptionPerLang = {};
                    // console.log("cal crear i assignar la descripció per l'idioma per defecte")
                    this.content.descriptionPerLang[this.defaultLang] = this.content.description;
                }else if (!this.content.descriptionPerLang[this.defaultLang]) {
                    // console.log("cal assignar la descripció per l'idioma per defecte")
                    this.content.descriptionPerLang[this.defaultLang] = this.content.description;
                }
            } 

            if (this.content.audio) {
                if (!this.content.audioPerLang) {
                    this.content.audioPerLang = {};
                    // console.log("cal crear i assignar l'àudio per l'idioma per defecte")
                    this.content.audioPerLang[this.defaultLang] = this.content.audio;
                }else if (!this.content.audioPerLang[this.defaultLang]) {
                    //console.log("cal assignar l'àudio per l'idioma per defecte")
                    this.content.audioPerLang[this.defaultLang] = this.content.audio;
                }
            } 

            if (this.content.video) {
                if (!this.content.videoPerLang) {
                    this.content.videoPerLang = {};
                    // console.log("cal crear i assignar el vídeo per l'idioma per defecte")
                    this.content.videoPerLang[this.defaultLang] = this.content.video;
                }else if (!this.content.videoPerLang[this.defaultLang]) {
                    // console.log("cal assignar el vídeo per l'idioma per defecte")
                    this.content.videoPerLang[this.defaultLang] = this.content.video;
                }
            } 

            if (this.content.url) {
                if (!this.content.urlPerLang) {
                    this.content.urlPerLang = {};
                    // console.log("cal crear i assignar la url per l'idioma per defecte")
                    this.content.urlPerLang[this.defaultLang] = this.content.url;
                }else if (!this.content.urlPerLang[this.defaultLang]) {
                    // console.log("cal assignar la url per l'idioma per defecte")
                    this.content.urlPerLang[this.defaultLang] = this.content.url;
                }
            } 

            if (this.content.url) {
                if (!this.content.urlPerLang) {
                    this.content.urlPerLang = {};
                    // console.log("cal crear i assignar la url per l'idioma per defecte")
                    this.content.urlPerLang[this.defaultLang] = this.content.url;
                }else if (!this.content.urlPerLang[this.defaultLang]) {
                    // console.log("cal assignar la url per l'idioma per defecte")
                    this.content.urlPerLang[this.defaultLang] = this.content.url;
                }
            } 

            if (this.content.files) {
                if (!this.content.filesPerLang) {
                    this.content.filesPerLang = {};
                    // console.log("cal crear i assignar els arxius per l'idioma per defecte")
                    this.content.filesPerLang[this.defaultLang] = this.content.files;
                }else if (!this.content.filesPerLang[this.defaultLang]) {
                    // console.log("cal assignar els arxius per l'idioma per defecte")
                    this.content.filesPerLang[this.defaultLang] = this.content.files;
                }
            }

            if (this.content.answers) {
                if (!this.content.answersPerLang) {
                    this.content.answersPerLang = {};
                    // console.log("cal crear i assignar les respostes per l'idioma per defecte")
                    this.content.answersPerLang[this.defaultLang] = this.content.answers;
                }else if (!this.content.answersPerLang[this.defaultLang]) {
                    // console.log("cal assignar les respostes per l'idioma per defecte")
                    this.content.answersPerLang[this.defaultLang] = this.content.answers;
                }
            }
        }  
    },
    mounted() {
        // console.log('mounted object', this.model,this.content,this.content.questions.length);
        this.collapsiblesGroup = bulmaCollapsible.attach('.new-object-group', {allowMultiple: false});

        
        
        this.originalContent = { ...this.content };
        // console.log(localStorage.getItem('token'));
        // console.log(this.model, this.content);

        this.$refs['imagesDropzone'].setOption(
            'previewTemplate',
            document.getElementById('image-preview-template').innerHTML
        );
        if (!this.isMultiLang) {
            this.$refs['audioDropzone'].setOption(
                'previewTemplate',
                document.getElementById('audio-preview-template').innerHTML
            );
            this.$refs['filesDropzone'].setOption(
                'previewTemplate',
                document.getElementById('files-preview-template').innerHTML
            );
        }
        

        if (this.content.images) {
            // console.log('content images', this.content.images);
            this.content.images.forEach((image) => {
                let file = {
                    size: image.size,
                    name: image.name,
                    type: image.mimeType,
                    draggable: true,
                };
                let url = image.url;
                this.$refs['imagesDropzone'].manuallyAddFile(file, url);
            });
        }

        if (this.content.audio && !this.isMultiLang) {
            // console.log('content audio', this.content.audio);
            let file = {
                size: this.content.audio.size,
                name: this.content.audio.name,
                type: this.content.audio.mimeType,
                draggable: true,
            };
            let url = this.content.audio.url;
            this.$refs['audioDropzone'].manuallyAddFile(file, url);
        }

        if (this.content.files && !this.isMultiLang) {
            // console.log('content files', this.content.files);
            this.content.files.forEach((elemet) => {
                let file = {
                    size: elemet.size,
                    name: elemet.name,
                    type: elemet.mimeType,
                    draggable: true,
                };
                let url = elemet.url;
                this.$refs['filesDropzone'].manuallyAddFile(file, url);
            });
        }

        this.$nextTick(() => {
            
        });
    },
    beforeDestroy() {
        //this.$refs['imagesDropzone'].
    },
    destroyed() {},
    methods: {
        
        isOpen(type) {
            // console.log(type,this.$refs[type])
            if (this.$refs[type]) {
                if (this.$refs[type].classList.contains('is-active')) {
                    return true;
                }
            }
            return false;
        },
        
        validateAndSave(questions) {
            //console.log("model",this.model)
            // console.log("(pas 2) data recived",questions)
            this.content.questions=questions;

            // console.log('model', this.model);
            const requiredMedia = _.chain(this.model.media)
                .filter((media) => media.required)
                .pluck('name')
                .concat()
                .value();
            // console.log('required media', requiredMedia);
            const requiredProps = _.chain(this.model)
                .pick((value, key) => {
                    return value.required;
                })
                .keys()
                .value();
            // console.log('required props', requiredProps);

            const requiredFields = requiredProps.concat(requiredMedia);

            // console.log('required fields', requiredFields);
            const props = _.chain(requiredFields);
            // console.log('props', props);
            props.forEach((prop) => {
                if (this.content[prop]) {
                    let dataLenght = 0;
                    if (typeof this.content[prop] == 'object') {
                        dataLenght = Object.keys(this.content[prop]).length;
                    } else {
                        dataLenght = this.content[prop].lenght;
                    }
                    if (dataLenght === 0) {
                        this.objectErrors[prop] = this.$t(
                            `Object.missing_${prop}_value`
                        );
                    } else {
                        if (this.objectErrors[prop]) {
                            delete this.objectErrors[prop];
                        }
                    }
                    if (prop === 'location') {
                        // console.log("checking content location", this.content[prop])
                        if (this.content[prop].latitude) {
                            if (this.isLatitude(this.content[prop].latitude)) {
                                this.content[prop].latitude = parseFloat(this.content[prop].latitude);
                            } else {
                                this.objectErrors[prop] = this.$t(
                                    `error_${prop}_value`
                                );
                            }
                        }
                        if (this.content[prop].longitude) {
                            if (this.isLongitude(this.content[prop].longitude)) {
                                this.content[prop].longitude = parseFloat(this.content[prop].longitude);
                            } else {
                                this.objectErrors[prop] = this.$t(
                                    `error_${prop}_value`
                                );
                            }
                        }
                    }
                    if (prop === 'title') { 
                        if (this.isMultiLang) {
                            if (this.$store.getters.project.defaultLang && this.content.titlePerLang[this.$store.getters.project.defaultLang]) {
                                this.content.title = this.content.titlePerLang[this.$store.getters.project.defaultLang];
                            }
                            if (!this.content.titlePerLang[this.$store.getters.project.defaultLang] || !this.content.titlePerLang[this.$store.getters.project.defaultLang].length) {
                                this.objectErrors[prop] = this.$t(`missing_${prop}_value_default_lang`);
                            }  
                            delete this.objectErrors[prop];
                        }
                    }
                } else {
                    if (prop === 'title') {
                        if (this.isMultiLang) {
                            if (!this.content.titlePerLang[this.$store.getters.project.defaultLang] || !this.content.titlePerLang[this.$store.getters.project.defaultLang].length) {
                                // console.log("adding error")
                                this.objectErrors['lang_' + this.$store.getters.project.defaultLang] = this.$t(`missing_${prop}_value_default_lang`);
                            } else {
                                this.content.title = this.content.titlePerLang[this.$store.getters.project.defaultLang];

                                delete this.objectErrors['lang_' + this.$store.getters.project.defaultLang]
                            }
                            delete this.objectErrors[prop];
                        }
                    } else {
                        this.objectErrors[prop] = this.$t(
                            `Object.missing_${prop}_value`
                        );
                    }
                }
            });

            if (this.isMultiLang) { 
                // console.log("comprovant camps multilingüe", this.content)
                let checkAudio = false;
                let checkVideo = false;
                let checkUrl = false;
                let checkFiles = false;

                let languages = this.$store.getters.project.langs;
                let defaultLang = this.$store.getters.project.defaultLang;
                let contentToCheck = { ...this.content }
                languages.forEach(function (lang) { 
                    // console.log("coprovant objecte principal",lang,contentToCheck)
                    if (contentToCheck.audioPerLang && contentToCheck.audioPerLang[lang]) {
                        if (lang != defaultLang) {
                            checkAudio = true;
                    }  
                    }
                    if (contentToCheck.videoPerLang && contentToCheck.videoPerLang[lang]) {
                        if (lang != defaultLang) {
                            checkVideo = true;
                        }  
                    }
                    if (contentToCheck.urlPerLang && contentToCheck.urlPerLang[lang]) {
                        if (lang != defaultLang) {
                            checkUrl = true;
                    }  
                    }
                    if (contentToCheck.filesPerLang && contentToCheck.filesPerLang[lang]) {
                        if (lang != defaultLang) {
                            checkFiles = true;
                    }  
                    }
                })
                if (checkAudio) {
                    // console.log("hi ha audio")  
                    if (!this.content.audioPerLang[this.$store.getters.project.defaultLang]) {
                        this.objectErrors['audio_lang_'+this.$store.getters.project.defaultLang] = this.$t(`missing_audio_value_default_lang`);
                    } else {
                        delete this.objectErrors['audio_lang_' + this.$store.getters.project.defaultLang];
                    }
                }
                if (checkVideo) {
                    // console.log("hi ha video")  
                    // console.log(this.content.videoPerLang[this.$store.getters.project.defaultLang])
                    if (!this.content.videoPerLang[this.$store.getters.project.defaultLang]) {
                        
                        this.objectErrors['video_lang_'+this.$store.getters.project.defaultLang] = this.$t(`missing_video_value_default_lang`);
                    } else {
                        delete this.objectErrors['video_lang_' + this.$store.getters.project.defaultLang];
                    }
                }
                if (checkFiles) {
                    // console.log("hi han arxius")  
                    if (!this.content.filesPerLang[this.$store.getters.project.defaultLang]) {
                        this.objectErrors['files_lang_'+this.$store.getters.project.defaultLang] = this.$t(`missing_files_value_default_lang`);
                    } else {
                        delete this.objectErrors['files_lang_' + this.$store.getters.project.filesLang];
                    }
                }
                if (checkUrl) {
                    // console.log("hi ha url")  
                    if (!this.content.urlPerLang[this.$store.getters.project.defaultLang]) {
                        this.objectErrors['url_lang_'+this.$store.getters.project.defaultLang] = this.$t(`missing_url_value_default_lang`);
                    } else {
                        delete this.objectErrors['url_lang_' + this.$store.getters.project.urlLang];
                    }
                }
            }

            // console.log("has errors?",this.objectErrors);
            const isValid = Object.keys(this.objectErrors).length === 0;
            if (isValid) {
                // console.log('(pas 2) is valid multiobject',this.content);
                this.$emit('saveMulti',this.content);
            } else {
                this.errorsOnSave = true;
            }
        },
        async searchAddress() {
            let searchLocale = this.$i18n.locale;
            if (this.$i18n.locale === 'ca-ES') {
                searchLocale = 'ca_ES';
            }
            if (this.searchText.length > 5) {
                const searchParams = {
                    q: this.searchText,
                    'accept-language': searchLocale,
                    limit: 1,
                };
                const geoCodingOSM = new GeoCodingOSM();

                const response = await geoCodingOSM.search(searchParams);

                if (response[0]) {
                    this.$emit('addPoint', response[0]);
                    // console.log(this.content);
                }else {
                    Swal.fire({
                        title: this.$t('no_address_found'),
                        text: this.$t('no_address_found_message'),
                        showCancelButton: false,
                        confirmButtonText: this.$t('userProfile.leave_school_continue'),
                    });
                }
            }
        },
        goToPos() {
            // console.log('in go to pos', this.content);
            if (this.content.location) {
                // console.log('has content location');
                if (
                    this.isLatitude(this.content.location.latitude) &&
                    this.isLongitude(this.content.location.longitude)
                ) {
                    this.$emit('addPoint', {
                        lat: this.content.location.latitude,
                        lon: this.content.location.longitude,
                    });
                }
            }
        },
        isLatitude(maybeLat) {
            var latF = parseFloat(maybeLat);
            if (isNaN(latF)) return false;
            return latF >= -90 && latF <= 90;
        },
        isLongitude(maybeLon) {
            var lonF = parseFloat(maybeLon);
            if (isNaN(lonF)) return false;
            return lonF >= -180 && lonF <= 180;
        },
        removeLocationNotification() {
            // console.log(this.$refs);
            this.$refs.location_notification.hidden = true;
        },
        imageAdded(file, response) {
            // console.log('adding file', file, response);
            if (!this.content.images) {
                this.content.images = [];
            }
            this.content.images.push(response.file);
        },
        imageRemoved(file, error, xhr){
            let removedImage = _.findWhere(this.content.images, {name: file.name, size:file.size});
            this.content.images = _.without(this.content.images,removedImage);
        },
        uploadImageError(file, message, xhr) {
            this.$refs['imagesDropzone'].removeFile(file);
            const errorMessage = '<i>' + file.name + '</i></br> ' + message;
            this.imagesErrors.push(errorMessage);
        },
        uploadAudioError(file, message, xhr) {
            // console.log(file, message, xhr);
            this.$refs['audioDropzone'].removeFile(file);
            const errorMessage = '<i>' + file.name + '</i></br> ' + message;
            this.audioErrors.push(errorMessage);
        },
        audioFileAdded(file, response) {
            this.content.audio = response.file;
            // console.log(file, response);
            // this.audioFile = response.file.url;
            // console.log(response.file.url);
            // this.showAudioPlayer = true;
        },
        audioRemoved(file, error, xhr){
            delete this.content.audio;
        },
        uploadFilesError(file, message, xhr) {
            // console.log(file, message, xhr);
            this.$refs['filesDropzone'].removeFile(file);
            const errorMessage = '<i>' + file.name + '</i></br> ' + message;
            this.filesErrors.push(errorMessage);
        },
        removeMessage(type, index) {
            if (type == 'files') {
                this.filesErrors.splice(index, 1);
            } else if (type == 'audio') {
                this.audioErrors.splice(index, 1);
            } else if (type == 'images') {
                this.imagesErrors.splice(index, 1);
            }
        },
        filesAdded(file, response) {
            // console.log(file, response);
            if (!this.content.files) {
                this.content.files = [];
            }
            this.content.files.push(response.file);
        },
        fileRemoved(file, error, xhr){
            let removedImage = _.findWhere(this.content.files, {name: file.name, size:file.size});
            this.content.files = _.without(this.content.files,removedImage);
        },
        previewVideo() {
            if (this.content.video) {
                this.previewData = this.$youtube.getIdFromUrl(
                    this.content.video
                );
                this.previewType = 'video';
                this.showModalPreview = true;
            }
        },
        previewEmbed() {
            if (this.content.embed) {
                this.previewType = 'embed';
                this.previewData = this.content.embed;
                this.showModalPreview = true;
            }
        },
        previewImages() {
            // console.log(this.content.images);
            if (this.content.images) {
                this.previewType = 'images';
                this.previewData = this.content.images;
                this.showModalPreview = true;
            }
        },
        showPreview(e) {
            // this.showPreviewModal = true;
            // console.log("content",this.content)
            // console.log("questions",e)
            this.content.questions=e;
            this.$emit("showPreview",this.content)
        },
        /*discardUnsavedChanges() {
            // console.log('discard');
            this.$emit('cancel');
        },*/

        /* data validations */
        validateVideoURL(event) {
            if (event.target.value.length) {
                const re =
                    /(\?v=([^#\&\?]{11}))|(youtu\.be\/([^#\&\?]{11})|(\&v=([^#\&\?]{11}))|(embed\/([^#\&\?]{11}))|(\/v\/([^#\&\?]{11})))/;
                if (re.test(event.target.value)) {
                    if (this.objectErrors.video) {
                        delete this.objectErrors.video;
                    }
                } else {
                    this.objectErrors.video = this.$t(
                        'Object.invalid_video_url'
                    );
                }
            } else {
                if (this.objectErrors.video) {
                    delete this.objectErrors.video;
                }
            }
        },
        validateEmbedCode(event) {
            if (event.target.value.length) {
                const re = /(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/;
                if (re.test(event.target.value)) {
                    if (this.objectErrors.embed) {
                        delete this.objectErrors.embed;
                    }
                } else {
                    this.objectErrors.embed = this.$t(
                        'Object.invalid_embed_code'
                    );
                }
            } else {
                if (this.objectErrors.embed) {
                    delete this.objectErrors.embed;
                }
            }
        },
        validateURL(event) {
            if (event.target.value.length) {
                const re =
                    /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
                if (re.test(event.target.value)) {
                    if (this.objectErrors.url) {
                        delete this.objectErrors.url;
                    }
                } else {
                    this.objectErrors.url = this.$t('Object.invalid_url');
                }
            } else {
                if (this.objectErrors.url) {
                    delete this.objectErrors.url;
                }
            }
        },
        imagesDragEndHandler(e) {
            const imagesLength = this.content.images.length;
            let imagesArray = [...this.content.images];
            const oldPositionImage = { ...imagesArray[e.oldIndex] };
            let newImagesArray = [];
            imagesArray.splice(e.oldIndex, 1);

            for (let i = 0; i < imagesLength; i++) {
                if (i == e.newIndex) {
                    newImagesArray.push(oldPositionImage);
                    if (imagesArray[i]) {
                        newImagesArray.push(imagesArray[i]);
                    }
                } else if (imagesArray[i]) {
                    newImagesArray.push(imagesArray[i]);
                }
            }
            this.content.images = newImagesArray;
        },
        filesDragEndHandler(e) {
            const filesLength = this.content.files.length;
            let filesArray = [...this.content.files];
            const oldPositionFile = { ...filesArray[e.oldIndex] };
            let newFilesArray = [];
            filesArray.splice(e.oldIndex, 1);

            for (let i = 0; i < filesLength; i++) {
                if (i == e.newIndex) {
                    newFilesArray.push(oldPositionFile);
                    if (filesArray[i]) {
                        newFilesArray.push(filesArray[i]);
                    }
                } else if (filesArray[i]) {
                    newFilesArray.push(filesArray[i]);
                }
            }
            this.content.files = newFilesArray;
        },
        deleteObject() {
            // console.log("on delete object");
            this.$emit('delete', this.content);
        },
        getAudioForLang(langCode) {
            if (this.content.audioPerLang) {
                return [this.content.audioPerLang[langCode]]|| [];
            }
            return [];
        },
        uploadError(data) {
            switch (data.type) {
                case "audio":
                    this.audioErrors.push(data.message);
                    break;
                case "files":
                    this.filesErrors.push(data.message);
                    break;
            }
            
        },
        getFilesForLang(langCode) {
            if (this.content.filesPerLang) {
                return this.content.filesPerLang[langCode]|| [];
            }
            return [];
        },
        fileAddedPerLang(data) {
            //console.log(data)
            switch (data.type) {
                case "audio":
                    if (!this.content.audioPerLang) {
                        this.content.audioPerLang = [];
                    }
                    this.content.audioPerLang[data.lang] = data.response.file;
                    // console.log(this.content.audioPerLang)
                    break;
                case "files": {
                    if (!this.content.filesPerLang) {
                        this.content.filesPerLang = [];
                    }
                    if (!this.content.filesPerLang[data.lang]) {
                        this.content.filesPerLang[data.lang] = [];
                    }
                    this.content.filesPerLang[data.lang].push(data.response.file);
                }
            }
        },
        fileRemovedPerLang(data) {
            //console.log(data)
            switch (data.type) {
                case "audio":
                    delete this.content.audioPerLang[data.lang];
                    break;
                case "files":
                    // console.log(this.content.filesPerLang,data.lang)
                    if (this.content.filesPerLang[data.lang]) {
                        let removedFile = _.findWhere(this.content.filesPerLang[data.lang], {name: data.file.name, size:data.file.size});
                        this.content.filesPerLang[data.lang] = _.without(this.content.filesPerLang[data.lang],removedFile);
                    }
                    
                    break;
            } 
            delete this.content.audio;
        },
        validateVideoURLPerLang(event) {
            // console.log(event,this.activeLanguage)
            if (event.target.value.length) {
                // console.log('checking')
                const re =
                    /(\?v=([^#\&\?]{11}))|(youtu\.be\/([^#\&\?]{11})|(\&v=([^#\&\?]{11}))|(embed\/([^#\&\?]{11}))|(\/v\/([^#\&\?]{11})))/;
                if (re.test(event.target.value)) {
                    // console.log('valid')
                    if (this.objectErrors.videoPerLang && this.objectErrors.videoPerLang[this.activeLanguage]) {
                        delete this.objectErrors.videoPerLang[this.activeLanguage];
                    }
                } else {
                     // console.log('invalid')
                    if (this.objectErrors.videoPerLang) {
                          // console.log('setting')
                        this.objectErrors.videoPerLang[this.activeLanguage] = this.$t('Object.invalid_video_url');
                    } else {
                          // console.log('initializing & setting')
                        this.objectErrors.videoPerLang = [];
                        this.objectErrors.videoPerLang[this.activeLanguage] = this.$t('Object.invalid_video_url');
                    }
                    
                }
            } else {
                //console.log("eliminant l'entrada de l'idioma")
                //delete this.content.videoPerLang[this.activeLanguage];

                if (this.objectErrors.videoPerLang && this.objectErrors.videoPerLang[this.activeLanguage]) {
                    // console.log("removing video error")
                    delete this.objectErrors.videoPerLang[this.activeLanguage];
                    delete this.content.videoPerLang[this.activeLanguage];
                }
            }
            // console.log(this.objectErrors.videoPerLang)

            let canRemove = true;
            if (this.objectErrors.videoPerLang) {
                this.$store.getters.project.langs.forEach((langCode) => {
                    if (this.objectErrors.videoPerLang[langCode]) {
                        canRemove = false;
                    }
                })
            }
            
            if (canRemove) {
                // console.log("removing video error")
                delete this.objectErrors.videoPerLang;
            }
        },
        validateURLPerLang(event) {
           // console.log(event,this.activeLanguage) 
            if (event.target.value.length) {
                const re =
                    /^(?:(?:(?:https):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
                if (re.test(event.target.value)) {
                    // console.log("valid")
                    if (this.objectErrors.urlPerLang && this.objectErrors.urlPerLang[this.activeLanguage]) {
                        // console.log("eliminant error anterior")
                        delete this.objectErrors.urlPerLang[this.activeLanguage];
                    }
                } else {
                    // console.log("invalid")
                    if (this.objectErrors.urlPerLang) {
                        // console.log("afegint error")
                        this.objectErrors.urlPerLang[this.activeLanguage] = this.$t('Object.invalid_url');
                    } else {
                        // console.log("inicialitzant i afegint error")
                        this.objectErrors.urlPerLang = [];
                        this.objectErrors.urlPerLang[this.activeLanguage] = this.$t('Object.invalid_url');
                    }
                    
                }
            } else {
                // console.log("buit")
                if (this.objectErrors.urlPerLang && this.objectErrors.urlPerLang[this.activeLanguage]) {
                    // console.log("eliminant error anterior")
                    delete this.objectErrors.urlPerLang[this.activeLanguage];
                    delete this.content.urlPerLang[this.activeLanguage];
                }
            }
            // console.log(this.objectErrors.urlPerLang)
            let canRemove = true;
            if (this.objectErrors.urlPerLang) {
                this.$store.getters.project.langs.forEach((langCode) => {
                    if (this.objectErrors.urlPerLang[langCode]) {
                        canRemove = false;
                    }
                })
            }
            if (canRemove) {
                // console.log("removing url error")
                delete this.objectErrors.urlPerLang;
            }
        },
    },
};
</script>

<style scoped>
    @import '~tippy.js/animations/shift-away.css';
    @import '../assets/css/tippyeduloc.css';
    @import '~vue2-dropzone/dist/vue2Dropzone.min.css';
    textarea {
        min-height: 3rem !important;
        resize: vertical;
    }
    .message {
        background-color: transparent;
        border-radius: 0;
        font-size: 1rem;
        margin-bottom: 0;
    }
    .message-header {
        border-radius: 0;
        padding-right: 0;
        background-color: #f4f4f4;
        border-bottom: 1px solid #d2d2d2;
    }

    .message
        a:not(.button):not(.lb-button):not(.lb-toolbar-button_images):not(.lb-toolbar-button_video):not(.lb-toolbar-button_files):not(.lb-toolbar-button_audio):not(.lb-toolbar-button_url):not(.lb-toolbar-button_location):not(.lb-toolbar-button_tags):not(.lb-toolbar-button_question):not(.lb-toolbar-button_object):not(.lb-toolbar-button_point):not(.lb-delete-media):not(.lb-answer):not(.lb-multiple-answer):not(.tag):not(.lb-bain-tag-functional):not(.lb-bain-tag-emotional):not(.lb-bain-tag-life-changer):not(.lb-bain-tag-social-impact):not(.lb-role-tag_administrator):not(.lb-role-tag_teacher):not(.lb-role-tag_student):not(.lb-role-tag_coordinator):not(.lb-role-tag_participant):not(.lb-role-tag_facilitator):not(.lb-status-tag_active):not(.lb-status-tag_inactive):not(.lb-status-tag_invited):not(.dropdown-item) {
        text-decoration: none;
    }
    .message-body.is-collapsible {
        overflow-x: hidden;
    }
    .action-buttons {
        position: absolute;
        bottom: 11px;
        width: 100%;
        left: 10px;
    }
    .action-buttons button {
        height: 60px;
    }

    .lb-bordered {
        border: 1px solid #dbdbdb;
        border-radius: 4px;
        box-shadow: inset 0 0.0625em 0.125em rgb(74 74 74 / 5%);
    }

    .lb-bordered:hover {
        border: 1px solid #b5b5b5;
    }

    .lb-bordered:focus-within {
        border: 1px solid #4a4a4a;
    }

    .lb-bordered /deep/ .buttons {
        border-radius: 4px 4px 0 0;
        margin-bottom: 0;
    }
    .lb-bordered /deep/ .editor__content {
        padding: 0.75rem;
    }
    .lb-bordered /deep/ .is-empty.editor-empty {
        display: none;
    }
    .is-borderless-left {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 0;
    }
    .is-radiusless-right {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .creation-helper:hover {
        cursor: pointer;
    }
    .creation-helper:hover i {
        /*color: #0074d9;*/
        color: var(--eduloc-red);
    }

    .dropzone {
        min-height: 80px;
        border-radius: 4px;
        border-width: 1px;
    }
    .sortable {
        padding: 0;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        list-style-type: none;
    }
    .sortable li {
        float: left;
        width: 115px;
        height: 115px;
        overflow: hidden;
        border: 1px solid #0074d9;
        text-align: center;
        margin: 5px;
        border-radius: 4px;
    }
    .sortable li:last-child {
        margin-bottom: 2rem;
    }
    .sortable li:hover {
        cursor: move;
    }
    li.sortable-placeholder {
        border: 1px dashed #ccc;
        background: none;
    }

    #accordion_new_object_group-images .dz-remove {
        position: relative;
        bottom: 88px;
        background-color: rgba(255, 255, 255, 0.6);
        float: right;
        padding: 4px;
        border-top-left-radius: 4px;
    }
    #accordion_new_object_group-images .dz-filename {
        position: relative;
        bottom: 113px;
        background-color: rgba(255, 255, 255, 0.6);
        padding-bottom: 2px;
        padding-top: 2px;
    }

    #accordion_new_object_group-audio .dropzone-previews,
    #accordion_new_object_group-files .dropzone-previews {
        padding: 0;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        list-style-type: none;
    }
    #accordion_new_object_group-audio .dropzone-previews li,
    #accordion_new_object_group-files .dropzone-previews li {
        border: 1px solid #0074d9;
        border-radius: 4px;
    }

    .validationErrors {
        position: absolute;
        z-index: +1;
        top: 20%;
    }

    .validationErrors .notification {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }

    #accordion_new_object_group-images .dz-preview.dz-file-preview .image.is-1by1 img {
        height: 100% !important;
        width: 100% !important;
        object-fit: cover !important;
    }

    #accordion_new_object_group-2 /deep/ .lb-accordion{
        max-height: unset;
    }
    #accordion_new_object_group-2 /deep/ .lb-accordion .message-header{
        background-color: white;
    }
    /*#information_link .lb-accordion .message-header .icon{
        color: var(--eduloc-blue);
    }*/
    #accordion_new_object_group-2 /deep/ .lb-accordion .message-header .active{
        background-color: var(--eduloc-blue-light);
    }
    #information_link > nav > div.level-left > div > div > span > span.icon.is-medium{
        color: var(--eduloc-blue);
    }
    #information_link > nav > div.level-right > div > span{
        color: var(--eduloc-blue);
    }

    .subgroup{
        padding-left: 2rem !important;
    }
    .subgroup.is-active{
        background-color: var(--eduloc-blue-light) !important;
    }
    .subgroup .icon{
        color: var(--eduloc-blue) !important;
    }
    .lang-field{
        display: none;
    }

    .lang-field.is-active{
        display: block;
    }

    .is-required{
        color: var(--eduloc-red);
        font-size: 0.75rem;
    }
</style>